/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementItem } from '../../models/asset-management-item';
import { BaseResponse } from '../../models/base-response';

export interface WarehouseControllerIsSerialInAssetManagement$Params {
  serialNo: string;
  product_id: number;
  office_id?: number;
  check_related_delivery?: boolean;
  check_related_ddt?: boolean;
  check_registry_end_customer_contact?: boolean;
}

export function warehouseControllerIsSerialInAssetManagement(http: HttpClient, rootUrl: string, params: WarehouseControllerIsSerialInAssetManagement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
  const rb = new RequestBuilder(rootUrl, warehouseControllerIsSerialInAssetManagement.PATH, 'get');
  if (params) {
    rb.path('serialNo', params.serialNo, {});
    rb.query('product_id', params.product_id, {});
    rb.query('office_id', params.office_id, {});
    rb.query('check_related_delivery', params.check_related_delivery, {});
    rb.query('check_related_ddt', params.check_related_ddt, {});
    rb.query('check_registry_end_customer_contact', params.check_registry_end_customer_contact, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementItem;
      }>;
    })
  );
}

warehouseControllerIsSerialInAssetManagement.PATH = '/warehouse/serialNumber/{serialNo}/isSerialInAssetManagement';
